import React, {Component} from 'react';
import PropTypes from "prop-types";

const MainHeader = (props) => {
    return (
        <header className="page__main__header">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8">
                        {props.children}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default MainHeader;

MainHeader.defaultProps = {
    children: '',
};

MainHeader.propTypes = {
    children: PropTypes.node,
};




// WEBPACK FOOTER //
// ./sources/js/components/layout/MainHeader.js